import { Card, CardHeader } from '../ui';
import { Bar, BarChart, CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { ReputationPeriod, ReputationTrendPoint } from '../../lib/api';

const PERIOD_LABELS: Record<ReputationPeriod, string> = {
  '7d': '7 дней',
  '30d': '30 дней',
  '90d': '3 месяца',
  year: 'Год',
};

interface ReputationSectionProps {
  period: ReputationPeriod;
  onPeriodChange: (period: ReputationPeriod) => void;
  trend: ReputationTrendPoint[];
  loading: boolean;
}

export function ReputationSection({ period, onPeriodChange, trend, loading }: ReputationSectionProps) {
  return (
    <Card>
      <CardHeader
        title="Репутация"
        action={
          <div className="flex gap-1 bg-gray-100 rounded-lg p-1">
            {(Object.keys(PERIOD_LABELS) as ReputationPeriod[]).map((key) => (
              <button
                key={key}
                type="button"
                onClick={() => onPeriodChange(key)}
                aria-pressed={period === key}
                className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
                  period === key ? 'bg-white shadow-sm text-gray-900' : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                {PERIOD_LABELS[key]}
              </button>
            ))}
          </div>
        }
      />

      {loading ? (
        <div className="h-64 flex items-center justify-center text-gray-400 text-sm">Загрузка...</div>
      ) : trend.length === 0 ? (
        <div className="h-64 flex items-center justify-center text-gray-400 text-sm">Недостаточно данных за выбранный период</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <p className="text-sm font-medium text-gray-500 mb-2">Динамика рейтинга</p>
            <ResponsiveContainer width="100%" height={220}>
              <LineChart data={trend}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
                <XAxis dataKey="date" tick={{ fontSize: 12 }} />
                <YAxis domain={[1, 5]} tick={{ fontSize: 12 }} />
                <Tooltip />
                <Line type="monotone" dataKey="avg" stroke="#f97316" strokeWidth={2} dot={{ r: 3 }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-500 mb-2">Новые отзывы</p>
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={trend}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
                <XAxis dataKey="date" tick={{ fontSize: 12 }} />
                <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
                <Tooltip />
                <Bar dataKey="count" fill="#4f46e5" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}
    </Card>
  );
}
